export const productConstants = {
  GETALL_REQUEST: 'PRODUCTS_GETALL_REQUEST',
  GETALL_SUCCESS: 'PRODUCTS_GETALL_SUCCESS',
  GETALL_FAILURE: 'PRODUCTS_GETALL_FAILURE',
  GETALL_LOADING: 'PRODUCTS_GETALL_LOADING',

  ADD_REQUEST: 'PRODUCTS_ADD_REQUEST',
  ADD_SUCCESS: 'PRODUCTS_ADD_SUCCESS',
  ADD_FAILURE: 'PRODUCTS_ADD_FAILURE',
  ADD_LOADING: 'PRODUCTS_ADD_LOADING',

  EDIT_REQUEST: 'PRODUCTS_EDIT_REQUEST',
  EDIT_SUCCESS: 'PRODUCTS_EDIT_SUCCESS',
  EDIT_FAILURE: 'PRODUCTS_EDIT_FAILURE',
  EDIT_LOADING: 'PRODUCTS_EDIT_LOADING',

  GET_REQUEST: 'PRODUCTS_GET_REQUEST',
  GET_SUCCESS: 'PRODUCTS_GET_SUCCESS',
  GET_FAILURE: 'PRODUCTS_GET_FAILURE',
  GET_LOADING: 'PRODUCTS_GET_LOADING',
}